// extracted by mini-css-extract-plugin
module.exports = {"md":"DebugPanelmenuIcon_md_3SdrE","ios":"DebugPanelmenuIcon_ios_CsV83","hiddenIcon":"DebugPanelmenuIcon_hiddenIcon_1yBAr"};